export default __webpack_public_path__ + "static/media/redTheme-girl.1ebbd52c.svg";